import styled from 'styled-components';


export const AdmMenuHome = styled.main`
	background: #000000D6;
  color: #ddd;

  .listagem {
    padding: 3%;
  };

  .listagem li {
    ${'' /* margin-bottom: 20px: */}
    margin-top: 21px;
    text-aling: center;
  };

  ul {
    margin-left: 30px;
  };

  li i {
    margin-right: 10px;
  };

  a:visited {
    color: darkorange;
  };

`;
